import { useMemo } from "react"
import { useReportedApprovalRequestsByDays } from "@/hooks/useApprovalRequest"
import { DateString } from "@/utils/dateString"

export const useReportedApprovalRequestsByDay = (targetDate: DateString) => {
    const { data: reportedApprovalRequestsByDays } =
        useReportedApprovalRequestsByDays({ targetDates: [targetDate] })

    return useMemo(() => {
        const reportedApprovalRequests =
            reportedApprovalRequestsByDays?.[targetDate] ?? []

        return { reportedApprovalRequests }
    }, [reportedApprovalRequestsByDays, targetDate])
}
